import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, NgModule } from '@angular/core';
import { LookupService } from '../../services/lookup.service';
import { Router } from '@angular/router';
import { FormControl, Validators, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { InvoiceService } from '../../services/invoice.service';
import { FileService } from '../../services/file.service';
import { UploadsModule } from '../shared/controls/uploads.component';
import { DialogModule } from 'primeng/dialog';
import { CommonModule, DatePipe } from '@angular/common';
import { ModalLeftNavModule } from '../shared/controls/dynamic/modal-left-nav.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { SimpleControlModule } from '../shared/controls/dynamic/simple-control.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { LoadingModule } from '../shared/controls/loading.component';
import { BaseFormComponent } from '../../models/base/base-form.component';
import { NotesDetailModule } from '../shared/controls/notes-detail.component';
import { NoteService } from '../../services/note.service';
import { NavigationService } from '../../services/navigation.service';
import { SharedService } from '../../services/shared.service';
import { Note } from '../../models/note.model';
import { environment } from '../../environments/environment';
import { ApplicationInsightsService } from '../../services/application-insights.service';
import * as Sentry from '@sentry/angular';
import { Subject, takeUntil } from 'rxjs';

export enum YesNoPartial {
  "Partial" = 1,
  "Yes" = 2,
  "No" = 3
}

export enum fscpaidbycustomer {
  "Partial" = 1,
  "Yes" = 2,
  "No" = 3,
  "Nothing Owed" = 4,
  "Uncollectible" = 5
}

export enum PaymentMethod {
  "Check" = 1,
  "Credit Card" = 2,
  "Paypal" = 3,
  "Venmo" = 4,
  "Zelle" = 5,
  "Wash" = 6,
  "ACH" = 7,
  "Other" = 8,
}

export enum CustomerChargedType {
  Prepay = 1,
  Invoice = 2,
  COD = 3,
  COP = 4
}
@Component({
  selector: 'invoice-form',
  templateUrl: './invoice-form.component.html',
  providers: [
    LookupService,
    NoteService
  ]
})
export class InvoiceFormComponent extends BaseFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() model: any = null;
  @Input() showHeader: boolean = true;
  @Input() showVehicles: boolean = true;
  @Input() mode: string = 'order';
  @Input() invoiceDetail: any = null;
  @Output() saveComplete = new EventEmitter();
  @Output() revertClose = new EventEmitter();
  @Output() markDirty = new EventEmitter();

  lookups: any = {}
  isAdmin: boolean = false;
  showSendModal = false;
  isUploading = false;
  isDeleting = false;
  uploadRequired = false;
  showRemainder = false;
  showWash = false;
  showfscPaidByOther = false;
  updateDate = false;
  carrierAdditionalPhones = [];
  driverPhones = [];
  driverNames = [];
  showPaymentOnHoldReasonModal: boolean = false
  carrierPaidStatus: any
  washedOnSelection;
  washedOnItems: any[] = [];
  washedOnItem;

  initialInvoiceSentDate: any;
  initialInvoiceDueDate: any;
  invoiceSentManually: boolean = false;
  isMarkComplete = false;
  isMoveCompletedRecord = false;
  form: FormGroup = new FormGroup({}, []);
  showBol = false;
  upload: any;
  showDeleteWarning = false;
  reloadNotes = false;
  isPaymentTermsReadOnly:boolean = false
  isAllFieldsReadonly:boolean = false
  subs = {};
  selectedContacts = [];
  selectedPaymentOnHoldReason = []
  today = new Date();
  metadata: any = {};
  deposit: number = 0;
  setDefaultDeliveryDate=false;
  setDefaultPickupDate=false;
  savedpaymentScheduleDate = null;
  private destroy$ = new Subject<void>();
  truckOverhaulOrderNumber:number = environment.truckOverhaulOrderNumber;
  isNewRecordForTruckOverhual:boolean =false;
  paymentOnHoldReasonList = [
    { value: 'On Hold, Claim on Another Order', label: 'On Hold, Claim on Another Order' },
    { value: 'BOL Missing Info', label: 'BOL Missing Info' },
    { value: 'Claim', label: 'Claim' },
    { value: 'Night Drop / Damage Confirm', label: 'Night Drop / Damage Confirm' },
    { value: 'Additional Receipts Required', label: 'Additional Receipts Required'},
    { value: 'Other', label: 'Other'}
  ]
  constructor(
    private lookupService: LookupService,
    private invoiceService: InvoiceService,
    private router: Router,
    private messageService: MessageService,
    private ref: ChangeDetectorRef,
    private datePipe: DatePipe,
    private fileService: FileService,
    private navigationService: NavigationService,
    private sharedService: SharedService,
    private noteService: NoteService,
    private applicationInsights: ApplicationInsightsService) {
    super();
  }

  ngOnInit() {
    this.applicationInsights.trackEvent('Invoice Form Opened', {
      invoiceId: this.model?.id,
      orderId: this.model?.orderId,
      orderNumber: this.model?.order?.number,
      mode: this.mode,
      timestamp: new Date().toISOString()
    });

    this.isAdmin = !!localStorage.getItem('isAdmin');

    this.loadLookup('yesNoNa');
    this.loadLookup('yesNoOnly');
    this.loadLookup('yesNo');
    this.loadLookup('yesNoPartial');
    this.loadLookup('fscpaidbycustomer');
    this.loadLookup('yesNoNull');
    this.loadLookup('yesNoNaNull');
    this.loadLookup('customerChargedType');
    this.loadLookup('carrierPaymentType');
    this.loadLookup('viewcarrierpaymenttype');
    this.loadLookup('sources');
    this.loadLookup('paymentTerms');
    this.loadLookup('transportResults');
    this.loadLookup('paymentMethod');
    this.loadLookup('paymentMethodDepositBy');
    this.loadLookup('stateCodes');
    this.loadLookup('yesNoNullPaymentHold');
    this.loadLookup('yesnonothingowed');
    this.loadForm();
    this.loadBol();
    this.calculateCompanyProfits();
    this.setValidationFSCPaidBy();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.anyChange('model', changes) && changes['model'].firstChange) {
      this.isAdmin = !!localStorage.getItem('isAdmin');
    }
    if (this.anyChange('model', changes)) {
      this.loadForm();
      this.calculateCompanyProfits();
    }
  }

  ngOnDestroy(): void {
    this.applicationInsights.trackEvent('Invoice Form Closed', {
      invoiceId: this.model?.id,
      orderId: this.model?.orderId,
      orderNumber: this.model?.order?.number,
      mode: this.mode,
      timestamp: new Date().toISOString()
    });

    this.safeUnsub("salesAgentCommissionPercentage");
    this.safeUnsub("carrierPaid");
    this.safeUnsub("paymentTerms");
    this.safeUnsub("invoicePaid");
    this.safeUnsub("salesAgentPaid");
    this.safeUnsub("dateReceived");
    this.safeUnsub("wash");
    this.safeUnsub("partialAmountPaid");
    this.safeUnsub("fscPaidBy");
    this.safeUnsub("fscPaidDate");
    this.safeUnsub("invoiceSentManually");
    this.safeUnsub("complete");
    this.safeUnsub("issueWithInvoices");
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService
      .get(key, force)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        this.lookups[key] = r;
        this.ref.detectChanges();
      });
  }

  loadBol() {
    this.fileService
      .list(this.model.order?.guid, 1)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (
          res.body != null &&
          res.body.results != null &&
          res.body.results.length > 0
        ) {
          this.upload = res.body.results;
        } else {
          this.upload = null;
        }

        this.ref.markForCheck();
      });
  }

  switchMode(mode: string) {
    this.mode = mode;

    switch (this.mode) {
      case 'order':
        break;
      case 'invoice':
        break;
    }

  }

  loadForm() {
    this.isLoading = true;
    let m = this.model;
    this.ref.markForCheck();

    if (m == null)
      m = { id: 0, order: null, metadata: {} };

    // Set readonly state based on order status
    this.isAllFieldsReadonly = m.order?.status === 6;
    
    // Trigger change detection to ensure UI updates
    this.ref.detectChanges();

    this.metadata = m.formMetadata;

    this.form = new FormGroup({}, []);

    if (this.model.number && this.model.number > this.truckOverhaulOrderNumber) {
      this.isNewRecordForTruckOverhual = true;
    }

    this.form.addControl('id', new FormControl(m.orderId));
    this.form.addControl('additionalCost', new FormControl(m.additionalCost || 3));
    this.form.addControl('additionalCostAmount', new FormControl(m.additionalCostAmount));
    this.form.addControl('achNotes', new FormControl(m.achNotes));
    this.form.addControl('assignedTo', new FormControl(m.assignedTo));

    this.form.addControl('dateReceived', new FormControl(m.dateReceived == null ? null : this.setDateFormat(m.dateReceived)));
    this.form.addControl('agentPaidDate', new FormControl(m.agentPaidDate == null ? null : this.setDateFormat(m.agentPaidDate)));
    this.form.addControl('reviewCompletedDate', new FormControl(m.reviewCompletedDate == null ? null : this.setDateFormat(m.reviewCompletedDate)));
    this.form.addControl('carrierPaymentDate', new FormControl(m.carrierPaymentDate == null ? null : this.setDateFormat(m.carrierPaymentDate)));
    this.form.addControl('IntialPaymentScheduledDate', new FormControl(null));
    this.form.addControl('wash', new FormControl(this.model.wash));
    this.form.addControl('carrierPaidDate', new FormControl(m.carrierPaidDate == null ? null : this.setDateFormat(m.carrierPaidDate)));
    this.form.addControl('paymentTerms', new FormControl(m.paymentTerms));
    if (m.order?.customerChargedType === 3 && m.order?.carrierPaymentType != 4 || m.order?.customerChargedType === 4 && m.order?.carrierPaymentType != 4) {
      if (m.order?.priceToCarrier != null && m.order?.balanceDue != null && m.order?.priceToCarrier <= m.order?.balanceDue) {
        this.isPaymentTermsReadOnly = true;
      }
    }

    if (m.order?.carrierPaymentType == 4 ||
      (
        (m.order?.carrierPaymentType == 1 || m.order?.carrierPaymentType == 2) && (m.order?.balanceDue < m.order?.priceToCarrier)
      )) {
      this.form.controls.paymentTerms.setValidators(Validators.required);
      this.form.controls.paymentTerms.updateValueAndValidity();
    } else {
      this.form.controls.paymentTerms.removeValidators(Validators.required);
      this.form.controls.paymentTerms.updateValueAndValidity();
    }

    this.navigationService.setCarrierPaymentTermsValue(m.paymentTerms);
    this.form.addControl('carrierPaid', new FormControl(m.carrierPaid));

    this.sharedService.changeCarrierPaidStatus(m.carrierPaid)
    this.form.addControl('fscPaidDate', new FormControl(m.fscPaidDate == null ? null : this.setDateFormat(m.fscPaidDate)));
    this.form.addControl('accountingNotes', new FormControl(m.accountingNotes));
    this.form.addControl('paymentNotes', new FormControl(m.paymentNotes));
    this.form.addControl('commissionNotes', new FormControl(m?.order?.commissionNotes));
    this.form.addControl('complete', new FormControl(m.complete));
    this.form.addControl('completeMoveUpdatedUser', new FormControl(m.completeMoveUpdatedUser));
    this.form.addControl('completeMoveUpdatedTimedate', new FormControl(m.completeMoveUpdatedTimedate));
    this.form.addControl('issueWithInvoices', new FormControl(m.issueWithInvoices));
    this.form.addControl('auditIssueNotes', new FormControl(m.auditIssueNotes));
    this.form.addControl('fscPaidBy', new FormControl(m.fscPaidBy == null ? null : m.fscPaidBy.toString()));
    this.form.addControl('fscPaidByOther', new FormControl(m.fscPaidByOther == null ? null : m.fscPaidByOther.toString()));
    this.form.addControl('invoicePaid', new FormControl(m.invoicePaid));
    this.form.addControl('sbi', new FormControl(m.sbi, [Validators.maxLength(25)]));

    this.form.addControl('partialAmountPaid', new FormControl(m.partialAmountPaid));
    this.form.addControl('balanceDue', new FormControl(m.balanceDue));
    this.form.addControl('remainderDue', new FormControl(m.remainderDue));
    this.form.addControl('companyProfit', new FormControl(m.companyProfit));
    this.form.addControl('adjustmentToProfit', new FormControl(m.adjustmentToProfit));
    this.form.addControl('adjustmentProfit', new FormControl(m.adjustmentProfit));
    this.form.addControl('factoring', new FormControl(m.factoring));
    this.form.addControl('carrierPaymentSpecialRequest', new FormControl(m.carrierPaymentSpecialRequest));

    this.form.addControl('agentCommission', new FormControl(m.agentCommission));
    this.form.addControl('paymentScheduledDate', new FormControl(m.paymentScheduledDate == null ? null : this.setDateFormat(m.paymentScheduledDate)));

    this.form.addControl('editInfo', new FormControl(false));

    this.form.addControl('billTo', new FormControl(m.billTo));
    this.form.addControl('billToName', new FormControl(m.billToName));
    this.form.addControl('billToLastName', new FormControl(m.billToLastName));
    this.form.addControl('billToCity', new FormControl(m.billToCity));
    this.form.addControl('billToStateCode', new FormControl(m.billToStateCode));
    this.form.addControl('billToAddress', new FormControl(m.billToAddress));
    this.form.addControl('billToZip', new FormControl(m.billToZip, [Validators.minLength(5), Validators.maxLength(5)]));
    this.form.addControl('billToPhone', new FormControl(m.billToPhone, [Validators.minLength(10), Validators.maxLength(18)]));
    this.form.addControl('billToEmail', new FormControl(m.billToEmail, [Validators.email]));

    this.form.addControl('contactFirstName', new FormControl(m.contactFirstName));
    this.form.addControl('contactLastName', new FormControl(m.contactLastName));
    this.form.addControl('contactEmail', new FormControl(m.contactEmail, [Validators.email]));
    this.form.addControl(
      "contactPhone",
      new FormControl({ value: m.contactPhone, disabled: true })
    );
    this.form.addControl('customerFirstName', new FormControl(m.customerFirstName));
    this.form.addControl('customerLastName', new FormControl(m.customerLastName));
    this.form.addControl('customerBusinessName', new FormControl(m.customerBusinessName));
    this.form.addControl('customerAddress', new FormControl(m.customerAddress));
    this.form.addControl('customerCity', new FormControl(m.customerCity));
    this.form.addControl('customerZip', new FormControl(m.customerZip, [Validators.minLength(5), Validators.maxLength(5)]));
    this.form.addControl('customerStateCode', new FormControl(m.customerStateCode));
    this.form.addControl('customerPhone', new FormControl(m.customerPhone, [Validators.minLength(10), Validators.maxLength(18)]));
    this.form.addControl('customerEmail', new FormControl(m.customerEmail, [Validators.email]));

    this.form.addControl('assignedCarrierName', new FormControl(m.assignedCarrierName));
    this.form.addControl('carrierPhone', new FormControl(m.carrierPhone));
    this.form.addControl('carrierBusinessPhone', new FormControl(m.carrierBusinessPhone));
    this.form.addControl('carrierAdditionalPhones', new FormControl(m.carrierAdditionalPhones));
    this.form.addControl('carrierAchOnFile', new FormControl(m.carrierACHOnFile));
    this.form.addControl('carrierAchNumber', new FormControl(m.carrierACHNumber));
    this.form.addControl('dispatcherName', new FormControl(m.dispatcherName));
    this.form.addControl('dispatcherEmail', new FormControl(m.dispatcherEmail));
    this.form.addControl('poNumber', new FormControl(m.poNumber));
    this.form.addControl('driverName', new FormControl(m.driverName));
    this.form.addControl('driverPhone', new FormControl(m.driverPhone));

    this.form.addControl('priceToCarrier', new FormControl(m.priceToCarrier));

    this.form.addControl('priceToCarrierAdjusted', new FormControl(m.priceToCarrierAdjusted));
    this.navigationService.setPriceToCarrierAdjustedValue(m.priceToCarrierAdjusted);
    // this.form.addControl('actualDeliveryDate', new FormControl(m.actualDeliveryDate ? this.setDateFormat(m.actualDeliveryDate) : null));
    this.form.addControl('actualDeliveryDate', new FormControl(m.actualDeliveryDate ? new Date(m.actualDeliveryDate) : null));

    if (m.priceToCarrierAdjusted !== undefined && m.additionalCostAmount !== undefined) {
      this.form.addControl('finalCarrierPayment', new FormControl(Number(m.priceToCarrierAdjusted) + Number(m.additionalCostAmount)));
    } else if (m.priceToCarrierAdjusted !== undefined) {
      this.form.addControl('finalCarrierPayment', new FormControl(Number(m.priceToCarrierAdjusted)));
    }

    this.initialInvoiceSentDate = m.invoiceSentDate;
    this.form.addControl('initialInvoiceSentDate', new FormControl(this.initialInvoiceSentDate));
    this.form.addControl('invoiceSentDate', new FormControl(m.invoiceSentDate == null ? null : new Date(m.invoiceSentDate)));
    this.initialInvoiceDueDate = m.invoiceDueDate;
    this.form.addControl('initialInvoiceDueDate', new FormControl(this.initialInvoiceDueDate));
    this.form.addControl('invoiceDueDate', new FormControl(m.invoiceDueDate == null ? null : new Date(m.invoiceDueDate)));
    this.form.addControl('invoiceSentManually', new FormControl(m.invoiceSentManually == null ? 3 : m.invoiceSentManually));


    if (m.fscPaidBy == 6) {
      if (m.washedOn && m.washedOnLabel) {
        this.washedOnItem = { id: m.washedOn, label: m.washedOnLabel };
        this.washedOnSelect(this.washedOnItem);
      }
    }

    if (this.isAdmin) {
      this.form.addControl(
        "salesAgentPaid",
        new FormControl(m.salesAgentPaid == null ? false : m.salesAgentPaid),
      );
      this.form.addControl(
        "salesAgentCommissionPercentage",
        new FormControl(m.salesAgentCommissionPercentage, [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          Validators.pattern(/^(0|[1-9]\d*)$/)
        ]),
      );
    }

    this.carrierAdditionalPhones = this.getStringArray(m.carrierAdditionalPhones, ';');
    this.driverPhones = this.sharedService.getDriverPhonesStringArray(m.order?.driverPhone);
    this.driverNames = this.getStringArray(m.order?.driverName, ',');

    this.subs['carrierPaid'] = this.form.get('carrierPaid').valueChanges.subscribe(v => {
      this.hideShowMarkComplete();
      this.showMarkCompleteWarning();
      this.changeCarrierPaid();
      if (v == 4) {
        this.addPaymentOnHoldReason()
      } else {
        this.showPaymentOnHoldReasonModal = false
      }
    });

    this.subs['paymentTerms'] = this.form.get('paymentTerms').valueChanges.subscribe(v => {
      this.calculatePriceToCarrier()
      this.calculatePaymentScheduledDate()
      this.navigationService.setCarrierPaymentTermsValue(v);
      this.navigationService.setPriceToCarrierAdjustedValue(this.form.get('priceToCarrierAdjusted')?.value);
      this.onChangeAdditionalCostAmount();
    });

    this.subs['invoicePaid'] = this.form.get('invoicePaid').valueChanges.subscribe(v => {
      this.setValidationFSCPaidBy();
      this.hideShowMarkComplete();
      this.showMarkCompleteWarning();
      this.paymentChanged();
      this.setFscPaidByValue()
      this.setFscPaidDateValue()
    });

    this.subs['salesAgentPaid'] = this.form.get('salesAgentPaid').valueChanges.subscribe(v => {
      this.hideShowMarkComplete();
      this.showMarkCompleteWarning();
      this.form.get('agentPaidDate').setValue(null);
      if(v == 0){ // no
        this.form.get('agentPaidDate').clearValidators();
        this.form.get('agentPaidDate').updateValueAndValidity();
      }
    });

    this.subs['dateReceived'] = this.form.get('dateReceived').valueChanges.subscribe(v => {
      this.dateReceivedChanged();
    });

    this.subs['wash'] = this.form.get('wash').valueChanges.subscribe(v => {
      this.calculatePriceToCarrier();
    });

    this.subs['partialAmountPaid'] = this.form.get('partialAmountPaid').valueChanges.subscribe(v => {
      this.paymentChanged();
    });

    this.subs['fscPaidBy'] = this.form.get('fscPaidBy').valueChanges.subscribe(v => {
      this.changePaidBy();
    });

    this.subs["fscPaidDate"] = this.form
      .get("fscPaidDate")
      .valueChanges.subscribe((v) => {
        this.setValidationFSCPaidDate(v);
      });

    this.subs['invoiceSentManually'] = this.form.get('invoiceSentManually').valueChanges.subscribe(v => {
      /**/
    });

    this.subs['salesAgentCommissionPercentage'] = this.form.get('salesAgentCommissionPercentage').valueChanges.subscribe(v => {
      this.calculateAgentCommission()
    });

    this.subs['complete'] = this.form.get('complete').valueChanges.subscribe(v => {
      this.showMarkCompleteWarning();
      if (v) {
        this.form.get('invoiceSentDate').updateValueAndValidity()
        this.form.get('invoiceDueDate').updateValueAndValidity()
      }
    });

    this.subs['issueWithInvoices'] = this.form.get('issueWithInvoices').valueChanges.subscribe(v => {
        if (v == 2) {
          this.isMarkComplete = false;
          this.form.get("complete").setValue(false);
          this.form.get("auditIssueNotes").setValidators([Validators.required]);
        } else {
          this.isMarkComplete = true;
          this.form.get("auditIssueNotes").clearValidators();
        }
        this.form.get("auditIssueNotes").updateValueAndValidity();
        this.form.get("complete").updateValueAndValidity();
    });

    this.paymentChanged();
    this.changePaidBy();
    this.hideShowMarkComplete();
    this.form.updateValueAndValidity();
    this.form.markAllAsTouched();
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.form.dirty) {
        this.markDirty.emit();
      }
    });

    setTimeout(() => {
      this.isLoading = false;
      this.ref.markForCheck();
    }, 100);
    this.dateReceivedChanged();
    if (this.model.order?.customerChargedType == CustomerChargedType.Prepay) {
      if (this.model.statusName == "Open") {
        this.form.patchValue({
          // invoicePaid: fscpaidbycustomer.Yes,
          fscPaidBy: PaymentMethod['Credit Card'].toString(),
          fscPaidDate: this.model?.depositPaymentDate ? this.setDateFormat(this.model.depositPaymentDate) : null
        });
      }
    }
    this.deposit = this.model.deposit ? this.model.deposit : 0;
    if (this.model.reviewRequired == 2) {
      this.ref.markForCheck();
    }
  }


  calculatePaymentScheduledDate() {
    let terms = this.form.get('paymentTerms').value,
     numDays = 0;
    let businessOnly = false;
    switch (terms) {
      case 1:
        numDays = 2;
        businessOnly = true;
        break;
      case 2:
        numDays = 5;
        businessOnly = true;
        break;
      case 3:
        numDays = 15;
        businessOnly = true;
        break;
      case 4:
        numDays = 20;
        businessOnly = true;
        break;
      case 5:
        numDays = 2;
        businessOnly = true;
        break;
      case 6:
        numDays = 5;
        businessOnly = true;
        break;
      case 7:
        numDays = 2;
        businessOnly = true;
        break;
    }

    let paymentScheduleDate = null;

    let customerChargedType = this.model?.order?.customerChargedType,
      carrierPaymentType = this.model?.order?.carrierPaymentType,
      priceToCarrier = this.model?.order?.priceToCarrier,
      balanceDue = this.model?.order?.balanceDue,
      depositRequired = this.model?.order?.depositRequired; //2-yes, 3-no

    if (
      (customerChargedType == 4 &&
        depositRequired == 2 &&
        carrierPaymentType == 2 &&
        +balanceDue == +priceToCarrier) ||
      (customerChargedType == 4 &&
        depositRequired == 2 &&
        carrierPaymentType == 2 &&
        +balanceDue > +priceToCarrier) ||
      (customerChargedType == 4 &&
        depositRequired == 3 &&
        carrierPaymentType == 2 &&
        +balanceDue == +priceToCarrier) ||
      (customerChargedType == 4 &&
        depositRequired == 3 &&
        carrierPaymentType == 2 &&
        +balanceDue > +priceToCarrier)
    ) {
      this.setDefaultPickupDate = true;
      let tmpDate = new Date(this.model?.actualPickupDate);
      paymentScheduleDate = new Date(tmpDate);
    } else if (
      (customerChargedType == 3 &&
        depositRequired == 3 &&
        carrierPaymentType == 1 &&
        +balanceDue > +priceToCarrier) ||
      (customerChargedType == 3 &&
        depositRequired == 3 &&
        carrierPaymentType == 1 &&
        +balanceDue == +priceToCarrier)
    ) {
      this.setDefaultDeliveryDate = true;
      let tmpDate = new Date(this.model?.actualDeliveryDate);
      paymentScheduleDate = new Date(tmpDate);
    } else {
      this.setDefaultDeliveryDate = false;
      this.setDefaultPickupDate = false;
      let tmpDate = new Date(this.model?.actualDeliveryDate);
      paymentScheduleDate = new Date(tmpDate);
    }

    while (numDays > 0) {
      paymentScheduleDate?.setDate(paymentScheduleDate.getDate() + 1);
      if (businessOnly && (new Date(paymentScheduleDate).getDay() == 6 || new Date(paymentScheduleDate).getDay() == 0))
        continue;
      numDays--;
    }
    this.savedpaymentScheduleDate = paymentScheduleDate;

    if (this.model.order?.carrierPaymentType) {
      if (this.model.order?.carrierPaymentType == 1 || this.model.order?.carrierPaymentType == 2) {
        if (this.model?.balanceDue
          && this.model?.priceToCarrier
          && this.model?.balanceDue > this.model?.priceToCarrier) {
          this.form.get('paymentScheduledDate').setValue(null);
        }
      }
    }
    this.setScheduledDate();
  }


calculatePriceToCarrier() {
  let terms = this.form.get('paymentTerms').value,
    priceToCarrier = this.model?.order?.priceToCarrier,
    wash = this.form.get('wash').value,
    balanceDue = this.model?.balanceDue,
    customerChargedType = this.model?.order?.customerChargedType,
    carrierPaymentType = this.model?.order?.carrierPaymentType;

  if (wash == null)
    wash = 0;

  if (terms == null) {
    this.form.get('priceToCarrierAdjusted')?.setValue(null);
    return
  }
  if ((customerChargedType == 3 && (carrierPaymentType == 1)) || (customerChargedType == 4 && (carrierPaymentType == 2))) {
    if ((+priceToCarrier > +balanceDue)) {
      if (terms == 1 || terms == 7) {
        this.form.get('priceToCarrierAdjusted')?.setValue(((+priceToCarrier - +balanceDue) - +wash - (0.05 * (+priceToCarrier - +balanceDue))).toFixed(2).toString());
      } else if (terms == 2) {
        this.form.get('priceToCarrierAdjusted')?.setValue(((+priceToCarrier - +balanceDue) - +wash - (0.03 * (+priceToCarrier - +balanceDue))).toFixed(2).toString());
      } else {
        this.form.get('priceToCarrierAdjusted')?.setValue(((+priceToCarrier) - +wash - +balanceDue).toFixed(2).toString());
      }
    } else if (((+priceToCarrier == +balanceDue) || +priceToCarrier < +balanceDue)) {
      this.form.get('priceToCarrierAdjusted')?.setValue((0).toString());
    }
  }
  else {
    if (terms == 1 || terms == 7) {
      this.form
        .get("priceToCarrierAdjusted")
        ?.setValue(
          (+priceToCarrier - 0.05 * +priceToCarrier - +wash)
            .toFixed(2)
            .toString()
        );
    } else if (terms == 2) {
      this.form
        .get("priceToCarrierAdjusted")
        ?.setValue(
          (+priceToCarrier - 0.03 * +priceToCarrier - +wash)
            .toFixed(2)
            .toString()
        );
    } else {
      this.form
        .get("priceToCarrierAdjusted")
        ?.setValue((+priceToCarrier - +wash).toFixed(2).toString());
    }
  }
}
  onCarrierPaidChange() {
    if (this.form.get('carrierPaid')?.value == null || this.form.get('carrierPaid')?.value == 3 || this.form.get('carrierPaid')?.value == 5 || this.form.get('carrierPaid')?.value == 6) {
      this.form.get('carrierPaidDate')?.setValue(null);
      this.form.get('achNotes')?.setValue(null);
    } else {
      this.form.get('carrierPaidDate')?.setValue(this.model.carrierPaidDate == null ? null : this.setDateFormat(this.model.carrierPaidDate));
      this.form.get('achNotes')?.setValue(this.model.achNotes);
    }
  }

  setDateFormat(date: any) {
    return this.datePipe.transform(date, 'MM/dd/yyyy', 'UTC');
  }

  showInvoice() {
    this.router.navigate(['/invoices'], { queryParams: { preview: this.model.invoiceId } });
  }

  save(status?: any) {
    this.applicationInsights.trackEvent('Invoice Save Started', {
      invoiceId: this.model?.id,
      orderId: this.model?.orderId,
      orderNumber: this.model?.order?.number,
      status: status,
      isValid: this.valid,
      timestamp: new Date().toISOString()
    });

    if (!this.valid && status != 'paymentOnHold')
      return;

    this.isLoading = true;

    if (this.form.value.dateReceived) {
      this.form.value.dateReceived = this.datePipe.transform(this.form.value.dateReceived, 'yyyy-MM-dd');
    }
    if (this.form.value.agentPaidDate) {
      this.form.value.agentPaidDate = this.datePipe.transform(this.form.value.agentPaidDate, 'yyyy-MM-dd');
    }
    if (this.form.value.carrierPaidDate) {
      this.form.value.carrierPaidDate = this.datePipe.transform(this.form.value.carrierPaidDate, 'yyyy-MM-dd');
    }
    if (this.form.value.fscPaidDate) {
      this.form.value.fscPaidDate = this.datePipe.transform(this.form.value.fscPaidDate, 'yyyy-MM-dd');
    }
    if (this.form.value.reviewCompletedDate) {
      this.form.value.reviewCompletedDate = this.datePipe.transform(this.form.value.reviewCompletedDate, 'yyyy-MM-dd');
    }
    if (this.form.value.paymentScheduledDate && this.form.value.dateReceived != null) {
      this.form.value.paymentScheduledDate = this.datePipe.transform(this.form.value.paymentScheduledDate, 'yyyy-MM-dd');
    }else{
      if(this.updateDate){
        this.form.value.paymentScheduledDate = null;
      }
    }
    let f = this.form.value;
    f.washedOn = this.washedOnSelection == null ? null : this.washedOnSelection.id;
    if (status == 'paymentOnHold') {
      f.selectedPaymentOnHoldReason = this.selectedPaymentOnHoldReason
      this.showPaymentOnHoldReasonModal = false
    }
    
    if (this.sharedService.getPermissions('completedmoves_uncheck_move_complete') == true && 
        this.form.get('complete')?.value == false && 
        this.model?.order?.status == 6) {
      f.invoiceReverted = true;
    } else {
      f.invoiceReverted = false;
    }
    
    this.hideShowMarkComplete();
    f.isReadyToAudit = this.isMarkComplete;
    this.form.markAsPristine();
    this.invoiceService
      .edit(f)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async (r) => {
          this.applicationInsights.trackEvent('Invoice Save Success', {
            invoiceId: this.model?.id,
            orderId: this.model?.orderId,
            orderNumber: this.model?.order?.number,
            status: status,
            isMarkComplete: this.isMarkComplete,
            timestamp: new Date().toISOString()
          });

          this.isLoading = false;
          if (this.model?.isReadyToAudit && f.isReadyToAudit && f.complete) {
            this.form.get("complete").setValue(f.isReadyToAudit);
            this.form.get("complete").updateValueAndValidity();
            this.isMarkComplete = false;
            this.model.order.status = 6;
            this.isMoveCompletedRecord = true;
          }
          if (f.complete) {
            this.sharedService.getMenuCount("order").subscribe((res) => {
              this.navigationService.menuCountChange(res.body, "order");
            });
          }
          this.sharedService.getMenuCount("invoice").subscribe((res) => {
            this.navigationService.menuCountChange(res.body, "invoice");
          });
          
          this.saveComplete.emit();
          this.ref.markForCheck();
          this.sharedService.changeCarrierPaidStatus(f.carrierPaid);
          this.carrierPaidStatus = f.carrierPaid;
          if (status == "paymentOnHold") {
            const noteInfo = {
              ...new Note(),
              entityId: f.id,
              entityName: "Invoice",
              message: this.selectedPaymentOnHoldReason.join(", "),
            };
            await this.addNote(noteInfo);
            this.reloadNotes = !this.reloadNotes;
            this.ref.detectChanges();
            this.selectedPaymentOnHoldReason = [];
            this.messageService.add(
              this.toast(true, "Payment on hold reason added successfully")
            );
          } else if (
            this.model.carrierPaid &&
            +this.model.carrierPaid === 4 &&
            +this.form.get("carrierPaid").value !== 4
          ) {
            const noteInfo = {
              ...new Note(),
              entityId: f.id,
              entityName: "Invoice",
              message: "Hold removed",
            };
            await this.addNote(noteInfo);
            this.reloadNotes = !this.reloadNotes;
            this.ref.detectChanges();
            this.messageService.add(this.toast(true, "Updated successfully"));
          } else {
            this.messageService.add(this.toast(true, "Updated successfully"));
          }
          this.model.carrierPaid = f.carrierPaid;
          this.navigationService.loadList(true);
        },
        (e) => {
          this.applicationInsights.trackException(e, 3);
          this.applicationInsights.trackEvent('Invoice Save Error', {
            invoiceId: this.model?.id,
            orderId: this.model?.orderId,
            orderNumber: this.model?.order?.number,
            error: e?.error?.message || e?.message || 'Unknown error',
            timestamp: new Date().toISOString()
          });

          Sentry.captureException(e);
          this.isLoading = false;
          this.ref.markForCheck();
          this.messageService.add(
            this.toast(true, e?.error?.message || "Something went wrong")
          );
          if (e && e.status && e.status == 404) {
            this.revertClose.emit();
            this.navigationService.loadList(true);
            this.sharedService
              .getMenuCount("invoice")
              .subscribe((res) => {
                this.navigationService.menuCountChange(res.body, "invoice");
              });
          }
        }
      );
  }

  async addNote(note: any) {
    return new Promise((resolve, reject) => {
      this.noteService
        .add(note)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res: any) => {
            return resolve(res);
          },
          (err) => {
            return reject(err);
          }
        );
    })
  }

  changeUploads(e: any) {
    /* */
  }

  changeUploadBol(e: any) {
    // if (this.upload?.length === 1 && (!e || e.length === 0)) {
    //   this.navigationService.loadList(true);
    // } else if (e && e.length && this.upload?.length != e.length) {
    //   this.navigationService.loadList(true);
    // }
    if (e) {
      this.upload = e.length <= 0 ? null : e;
    }
  }

  changeCarrierPaid() {

    this.form.get('carrierPaidDate').clearValidators();
    this.form.get('achNotes').clearValidators();

    if (this.form.get('carrierPaid').value == 2) { //yes
      this.form.get('carrierPaidDate').setValidators(Validators.required);
      this.form.get('achNotes').setValidators(Validators.required);
    }

    this.form.get('carrierPaidDate').updateValueAndValidity();
    this.form.get('achNotes').updateValueAndValidity();

    this.ref.markForCheck();
  }

  addPaymentOnHoldReason() {
    this.showPaymentOnHoldReasonModal = true
  }

  closePaymentReasonDialog() {
    this.form.get('carrierPaid')?.setValue(this.carrierPaidStatus ? this.carrierPaidStatus : this.model.carrierPaid)
    this.showPaymentOnHoldReasonModal = false
    this.selectedPaymentOnHoldReason = []
  }

  changePaidBy() {

    let fscPaidBy = this.form.get('fscPaidBy');

    if (fscPaidBy.value == 6) {
      this.showWash = true;
    } else {
      this.showWash = false;
    }

    this.showfscPaidByOther = (fscPaidBy.value == 8);

    this.ref.markForCheck();
  }

  invoiceSentManuallyChanged() {
    if (this.form.get('invoiceSentManually').value == 2) { //yes
      this.invoiceSentManually = true;
      if (this.initialInvoiceSentDate == null) {
        this.form.get('invoiceSentDate').setValue(new Date());
      }
      if (this.initialInvoiceDueDate == null) {
        this.form.get('invoiceDueDate').setValue(new Date());
      }
    } else {
      this.invoiceSentManually = false;
      this.form.get('invoiceSentDate').setValue(this.initialInvoiceSentDate == null ? null : new Date(this.initialInvoiceSentDate));
      this.form.get('invoiceSentDate').clearValidators();
      this.form.get('invoiceDueDate').setValue(this.initialInvoiceDueDate == null ? null : new Date(this.initialInvoiceDueDate));
      this.form.get('invoiceDueDate').clearValidators();
    }

    this.form.get('invoiceSentDate').updateValueAndValidity();
    this.form.get('invoiceDueDate').updateValueAndValidity();
    this.ref.markForCheck();
  }

  paymentChanged() {
    if (this.form.get('invoicePaid').value == 1) { //partial
      this.showRemainder = true;
      this.form.get('partialAmountPaid').setValidators([Validators.required]);
      this.form.get('partialAmountPaid').updateValueAndValidity({ emitEvent: false });

    } else {
      this.showRemainder = false;
      this.form.get('partialAmountPaid').clearValidators();
      this.form.get('partialAmountPaid').updateValueAndValidity({ emitEvent: false });

    }

    if (this.showRemainder) {
      let balance = this.form.get("balanceDue").value;
      let partial = this.form.get("partialAmountPaid").value;
      let customerChargedType = this.model?.order?.customerChargedType,
        carrierPaymentType = this.model?.order?.carrierPaymentType;
      const brokerFee: any = this.getBrokerFee();
      if (customerChargedType == 2 && carrierPaymentType == 4) {
        this.form.get("remainderDue").setValue(balance - partial);
      } else if (customerChargedType == 1 && carrierPaymentType == 4) {
        this.form.get("remainderDue").setValue(this.deposit - partial);
      } else if (
        customerChargedType == 3 &&
        carrierPaymentType == 1
      ) {
        this.form
        .get("remainderDue")
        .setValue(Number(this.deposit) + Number(brokerFee) - Number(partial));
      } else if (
        customerChargedType == 4 &&
        carrierPaymentType == 2
      ) {
        this.form
        .get("remainderDue")
        .setValue(Number(this.deposit) + Number(brokerFee) - Number(partial));
      } else {
        this.form.get("remainderDue").setValue(null);
      }
    }
  }

  setFscPaidByValue() {
    if (this.form.get("invoicePaid").value == 3 || this.form.get("invoicePaid").value == 5) {
      this.form.get("fscPaidBy").setValue(null);
      this.form.get("fscPaidBy").clearValidators();
      this.form.get("fscPaidBy").updateValueAndValidity();
    }
  }

  setFscPaidDateValue() {
    if (this.form.get("invoicePaid").value == 3 || this.form.get("invoicePaid").value == 5) {
      this.form.get("fscPaidDate").setValue(null);
      this.form.get("fscPaidDate").clearValidators();
      this.form.get("fscPaidDate").updateValueAndValidity();
    }
  }

  setValidationFSCPaidBy() {
    this.form.get('fscPaidBy').clearValidators();
    this.form.get('fscPaidBy').updateValueAndValidity();
    this.form.get('fscPaidDate').clearValidators();
    this.form.get('fscPaidDate').updateValueAndValidity();
    if (this.form.get('invoicePaid').value == 1 || this.form.get('invoicePaid').value == 2) {
      this.form.get('fscPaidBy').setValidators([Validators.required]);
      this.form.get('fscPaidDate').setValidators([Validators.required]);
      this.form.get("fscPaidBy").updateValueAndValidity({ emitEvent: true });
      this.form.get("fscPaidDate").updateValueAndValidity({ emitEvent: true });
    }
  }

  setValidationFSCPaidDate(fscPaidDate) {
    const fields = ["invoicePaid", "fscPaidBy"];

    fields.forEach((field) => {
      const control = this.form.get(field);
      if (
        control?.value == null &&
        (fscPaidDate ||
          this.form.get("invoicePaid").value == 1 ||
          this.form.get("invoicePaid").value == 2)
      ) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
      }
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }

  hideShowMarkComplete() {

    if((this.model?.status == 3 || this.isMoveCompletedRecord ) && this.sharedService.getPermissions('completedmoves_uncheck_move_complete') === false) {
      this.isMarkComplete = false;
      return;
    }

    this.isMarkComplete = false;
      if (this.form.get('assignedTo')?.value == 3 || this.form.get('assignedTo')?.value == 5864 || this.form.get('assignedTo')?.value == 5865) {
        if ((this.form.get('invoicePaid').value == 2 || this.form.get('invoicePaid').value == 4 || this.form.get('invoicePaid').value == 5)
          && (this.form.get('carrierPaid').value == 2 || this.form.get('carrierPaid').value == 5)) {
          this.isMarkComplete = true;
        } else {
          this.isMarkComplete = false;
        }
      } else {
        if ((this.form.get('invoicePaid').value == 2 || this.form.get('invoicePaid').value == 4 || this.form.get('invoicePaid').value == 5)
          && (this.form.get('carrierPaid').value == 2 || this.form.get('carrierPaid').value == 5)
          && (this.form.get('salesAgentPaid').value == 1 || this.form.get('salesAgentPaid').value == 2)) {
          this.isMarkComplete = true;
        } else {
          this.isMarkComplete = false;
        }
      }
    // if (this.model?.isReadyToAudit) {
    //   this.form.get('complete').setValue(false);
    // }
  }

  showMarkCompleteWarning() {
    let v = this.form.get('complete').value;

    if (!v) {
      this.form.get('invoiceSentDate').clearValidators();
      this.form.get('invoiceSentDate').updateValueAndValidity()

      this.form.get('invoiceDueDate').clearValidators();
      this.form.get('invoiceDueDate').updateValueAndValidity()

      this.form.get('agentPaidDate').clearValidators();
      this.form.get('agentPaidDate').updateValueAndValidity()

      if (this.model != null && this.form.get('assignedTo')?.value != 3 && this.form.get('salesAgentPaid')?.value == 1) {
        this.form.get('agentPaidDate').setValidators([Validators.required]);
        this.form.get('agentPaidDate').updateValueAndValidity()
      }
    } else {
      if (this.model != null && this.form.get('invoiceSentDate')?.value == null) {
        this.form.get('invoiceSentDate').updateValueAndValidity()
      }
      if (this.model != null && this.form.get('invoiceDueDate')?.value == null) {
        this.form.get('invoiceDueDate').updateValueAndValidity()
      }

      if (this.model != null && this.form.get('assignedTo')?.value != 3 && this.form.get('salesAgentPaid')?.value == 1) {
        this.form.get('agentPaidDate').setValidators([Validators.required]);
        this.form.get('agentPaidDate').updateValueAndValidity()
      }
    }
  }

  send() {
    this.isLoading = true;

    let m: any = {};
    m.id = this.model.id;
    m.selectedContacts = this.selectedContacts;

    this.invoiceService
      .send(m)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        this.isLoading = false;
        this.showSendModal = false;
        this.messageService.add(this.toast(true, "Sent successfully"));
        this.saveComplete.emit();
      });
  }


  washedOnSearch(e: any) {
    this.lookupService
      .ordersWithActiveInvoice(this.model?.order?.guid, e.query)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.washedOnItems = res.body;
        this.ref.markForCheck();
      });
  }

  washedOnSelect(e: any) {
    this.washedOnSelection = e;
  }

  dateReceivedChanged() {
    let v = this.form.get('dateReceived').value;
    if (v == null) {
      this.uploadRequired = false;
    } else {
      this.uploadRequired = true;
    }
    this.calculatePaymentScheduledDate();
  }

  setScheduledDate(): void {
    let customerChargedType = this.model?.order?.customerChargedType,
    carrierPaymentType = this.model?.order?.carrierPaymentType,
    priceToCarrier = this.model?.order?.priceToCarrier,
    balanceDue = this.model?.order?.balanceDue,
    depositRequired = this.model?.order?.depositRequired//2-yes, 3-no
    let v = new Date(this.form.get('dateReceived')?.value);
    let diffDays = Math.floor((Date.UTC(v.getFullYear(), v.getMonth(),
    v.getDate()) - Date.UTC(this.savedpaymentScheduleDate?.getFullYear(),
    this.savedpaymentScheduleDate?.getMonth(),
    this.savedpaymentScheduleDate?.getDate()) ) /(1000 * 60 * 60 * 24));
    if ((customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier)
      || (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier)
      || (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier)
      || (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier)
    ) {
      this.updateDate = false;
    }
    else if ((customerChargedType == 3 && depositRequired == 2 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier)
      || (customerChargedType == 3 && depositRequired == 3 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 2 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 2 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier)
      || (customerChargedType == 4 && depositRequired == 3 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier)
      || (customerChargedType == 2 && depositRequired == 3 && carrierPaymentType == 4)
      || (customerChargedType == 1 && depositRequired == 2 && carrierPaymentType == 4 && +balanceDue < +priceToCarrier)) {
      this.updateDate = true;
    }

    if (v && this.updateDate && (v >= this.savedpaymentScheduleDate || diffDays >= 0)) {
      const date = new Date(v);
      if (new Date(v).getDay() == 5) {
        date.setDate(date.getDate() + 3); // Skip Saturday and Sunday Date
      } else if (new Date(v).getDay() == 6) {
        date.setDate(date.getDate() + 2); // Skip Sunday Date
      }
      else {
        date.setDate(date.getDate() + 1);
      }
      let updatedScheduleDate = this.datePipe.transform(date, 'MM/dd/yyyy');
      this.form.get('paymentScheduledDate')?.setValue(updatedScheduleDate);
      this.form.updateValueAndValidity();
    }
    else if(v && this.savedpaymentScheduleDate){
      const date = new Date(this.savedpaymentScheduleDate);
      if(this.form.get('paymentScheduledDate').value!=null && !this.setDefaultDeliveryDate && !this.setDefaultPickupDate ){
        if(new Date(this.savedpaymentScheduleDate).getDay() == 6){
          date.setDate(date.getDate() + 2); // Skip Saturday and Sunday Date
        }
        else if(new Date(this.savedpaymentScheduleDate).getDay() == 0){
          date.setDate(date.getDate() + 1); // Skip Sunday Date
        }
      }
      let updatedScheduleDate = this.datePipe.transform(date, 'MM/dd/yyyy');
      this.form.get('paymentScheduledDate')?.setValue(updatedScheduleDate);
      this.form.updateValueAndValidity();
    }else{
      this.form.get('paymentScheduledDate')?.setValue(this.savedpaymentScheduleDate);
    }
  }

  get valid(): boolean {
    return this.form.valid && (this.uploadRequired ? this.upload != null : true) && (this.showWash ? this.washedOnItem != null && this.washedOnItem.id : true);
  }

  get completeWarningFields(): string {
    let fields = [];

    if (this.form.get('invoicePaid').value != 2) {
      fields.push("FSC Paid");
    }
    if (this.form.get('salesAgentPaid').value == 0 && this.form.get('assignedTo')?.value != 3) {
      fields.push("Agent Paid");
    }
    if (this.form.get('carrierPaid').value != 2) {
      fields.push(" Carrier Paid");
    }

    if (fields.length == 1) {
      return fields[0];
    }
    else if (fields.length == 2) {
      return fields[0] + " and " + fields[1];
    } else if (fields.length == 3) {
      return fields[0] + ", " + fields[1] + ', and ' + fields[2];
    } else {
      return "";
    }
  }

  logForm() {
    console.log(this.form);
  }

  onChangeAdjustmentToprofit() {
    if (
      this.form.get("adjustmentToProfit")?.value !== undefined &&
      this.form.get("companyProfit")?.value !== undefined
    ) {
      this.form
        .get("adjustmentProfit")
        ?.setValue(
          Number(this.form.get("companyProfit")?.value) +
          Number(this.form.get("adjustmentToProfit")?.value)
        );
      this.form.get('adjustmentProfit').updateValueAndValidity();
    } else if (this.form.get("companyProfit")?.value !== undefined) {
      this.form
        .get("adjustmentProfit")
        ?.setValue(this.form.get("companyProfit")?.value);
      this.form.get('adjustmentProfit').updateValueAndValidity();
    } else if (this.form.get("adjustmentToProfit")?.value !== undefined) {
      this.form
        .get("adjustmentProfit")
        ?.setValue(this.form.get("adjustmentToProfit")?.value);
      this.form.get('adjustmentProfit').updateValueAndValidity();
    }

    // If additionalCostAmount is present then update adjustmentProfit value
    if (this.form.get("additionalCostAmount")?.value !== undefined &&
      !Number.isNaN(Number(this.form.get("additionalCostAmount")?.value)) &&
      Number(this.form.get("additionalCostAmount")?.value) > 0) {
      this.form.get("adjustmentProfit")?.setValue(
        Number(this.form.get("adjustmentProfit")?.value) -
        Number(this.form.get("additionalCostAmount")?.value)
      );
    }
    this.calculateAgentCommission();
  }

  onChangeAdditionalCostAmount() {
    if (this.form.get("additionalCostAmount")?.value === '' || this.form.get("additionalCostAmount")?.value === null) {
      this.form.get("finalCarrierPayment")?.setValue(
        Number(this.form.get("priceToCarrierAdjusted")?.value)
      );
      this.form.get('finalCarrierPayment').updateValueAndValidity();
      this.onChangeAdjustmentToprofit();
    } else if (this.form.get("additionalCostAmount")?.value !== undefined &&
      !Number.isNaN(Number(this.form.get("additionalCostAmount")?.value)) &&
      Number(this.form.get("additionalCostAmount")?.value) > 0) {
      if (this.form.get("priceToCarrierAdjusted")?.value !== undefined) {
        this.form.get("finalCarrierPayment")?.setValue(
          Number(this.form.get("priceToCarrierAdjusted")?.value) +
          Number(this.form.get("additionalCostAmount")?.value)
        );
        this.form.get('finalCarrierPayment').updateValueAndValidity();
      }
      this.onChangeAdjustmentToprofit();
    }
  }

  getBrokerFee() {
    let customerChargedType = this.model?.order?.customerChargedType,
      carrierPaymentType = this.model?.order?.carrierPaymentType,
      priceToCarrier = this.model?.order?.priceToCarrier,
      balanceDue = this.model?.balanceDue,
      depositRequired = this.model?.order?.depositRequired;

    if (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier) {
      return null;
    } else if (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier) {
      return (+balanceDue - +priceToCarrier)?.toFixed(2).toString();
    } else if (customerChargedType == 3 && depositRequired == 2 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier) {
      return null;
    } else if (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier) {
      return 0;
    } else if (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier) {
      return (+balanceDue - +priceToCarrier)?.toFixed(2).toString();
    } else if (customerChargedType == 3 && depositRequired == 3 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier) {
      return 0;
    } else if (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier) {
      return null;
    } else if (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier) {
      return (+balanceDue - +priceToCarrier)?.toFixed(2).toString();
    } else if (customerChargedType == 4 && depositRequired == 2 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier) {
      return null;
    } else if (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier) {
      return 0;
    } else if (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier) {
      return (+balanceDue - +priceToCarrier)?.toFixed(2).toString();
    } else if (customerChargedType == 4 && depositRequired == 3 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier) {
      return 0;
    } else if (customerChargedType == 2 && depositRequired == 3 && carrierPaymentType == 4) {
      return null;
    } else if (customerChargedType == 1 && depositRequired == 2 && carrierPaymentType == 4 && +balanceDue < +priceToCarrier) {
      return null;
    } else {
      if (+balanceDue > +priceToCarrier) {
        return (+balanceDue - +priceToCarrier)?.toFixed(2).toString();
      } else {
        return null;
      }
    }
  }

  calculateCompanyProfits() {
    let formValue = this.form.getRawValue();
    let profit = 0;
    if (this.model?.order?.customerChargedType) {
      profit = this.deposit + (formValue.balanceDue - this.model.priceToCarrier)
    }
    this.model.companyProfit = profit;
    formValue.companyProfit = profit;
    this.form.get('companyProfit').setValue((Math.sign(profit) * Math.abs(Math.round(Math.sign(profit) * profit * 100) / 100)).toFixed(2));
    this.newSubtractCommission();
    //this.subtractCommission();
    this.onChangeAdjustmentToprofit();
  }


  newSubtractCommission() {
    let formValue = this.form.getRawValue();
    const brokerFee: any = this.getBrokerFee();
    const customerChargedType = this.model?.order?.customerChargedType;
    const depositRequired = this.model?.order?.depositRequired;
    let isdeducted = false;
    let profit = this.deposit + (formValue.balanceDue - this.model.priceToCarrier)

    // deduction from Deposit
    if ((this.model.order.depositBy == PaymentMethod['Credit Card'] || this.model.order.depositBy == PaymentMethod.Paypal) ||
      (brokerFee > 0
        && (+this.model.order.brokerFeePaymentMethod != PaymentMethod['Credit Card'] || +this.model.order.brokerFeePaymentMethod != PaymentMethod.Paypal || +this.model.order.brokerFeePaymentMethod == null)
        && (this.model.order.depositBy != PaymentMethod['Credit Card'] || this.model.order.depositBy != PaymentMethod.Paypal)
        && (formValue.fscPaidBy == PaymentMethod['Credit Card'] || formValue.fscPaidBy == PaymentMethod.Paypal))) {
      //10
      if (this.deposit) {
        profit = (profit) + (-(this.deposit * (environment.percentage_of_deduction / 100)));
        isdeducted = true;
      }
      this.model.companyProfit = profit;
      this.form.get('companyProfit').setValue((Math.sign(profit) * Math.abs(Math.round(Math.sign(profit) * profit * 100) / 100)).toFixed(2));
      this.form.get('companyProfit').updateValueAndValidity()
    }

    // deduction from brocker fee
    let currentCompanyProfit: any =  profit;
    if (brokerFee > 0
      && (+this.model.order.brokerFeePaymentMethod == PaymentMethod['Credit Card'] || +this.model.order.brokerFeePaymentMethod == PaymentMethod.Paypal)) {
      currentCompanyProfit = (currentCompanyProfit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));
      this.model.companyProfit = profit;
      this.form.get('companyProfit').setValue((Math.sign(currentCompanyProfit) * Math.abs(Math.round(Math.sign(currentCompanyProfit) * currentCompanyProfit * 100) / 100)).toFixed(2));
      this.form.get('companyProfit').updateValueAndValidity();
    }
    else if (!isdeducted && (formValue.fscPaidBy == PaymentMethod['Credit Card'] || formValue.fscPaidBy == PaymentMethod.Paypal)) {
      if (this.deposit) {
        currentCompanyProfit = (currentCompanyProfit) + (-(this.deposit * (environment.percentage_of_deduction / 100)));
      }
      else if (brokerFee > 0) {
        currentCompanyProfit = (currentCompanyProfit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));
      } else {
        currentCompanyProfit = (currentCompanyProfit) + (-((+this.model.order.price) * (environment.percentage_of_deduction / 100)));
      }
      this.model.companyProfit = currentCompanyProfit;
      this.form.get('companyProfit').setValue((Math.sign(currentCompanyProfit) * Math.abs(Math.round(Math.sign(currentCompanyProfit) * currentCompanyProfit * 100) / 100)).toFixed(2));
      this.form.get('companyProfit').updateValueAndValidity();
    }

      // for uncollectible

      if(this.form.get('invoicePaid')?.value == 5){
        if (customerChargedType == 2) {
          currentCompanyProfit = currentCompanyProfit - (formValue.balanceDue ?? 0);
        } else if ((customerChargedType == 3 || customerChargedType == 4) && depositRequired == 3) {
          currentCompanyProfit = currentCompanyProfit - (brokerFee ?? 0);
        }
        this.model.companyProfit = currentCompanyProfit;
        this.form.get('companyProfit').setValue((Math.sign(currentCompanyProfit) * Math.abs(Math.round(Math.sign(currentCompanyProfit) * currentCompanyProfit * 100) / 100)).toFixed(2));
        this.form.get('companyProfit').updateValueAndValidity();
        }
  }


  // subtractCommission() {
  //   let formValue = this.form.getRawValue();
  //   if ((this.model?.order?.customerChargedType) && (formValue.fscPaidBy == PaymentMethod['Credit Card'] || formValue.fscPaidBy == PaymentMethod.Paypal || this.model.order.depositBy == PaymentMethod['Credit Card'] || this.model.order.depositBy == PaymentMethod.Paypal)) {
  //     let profit = (this.deposit) + (formValue.balanceDue - this.model.priceToCarrier);
  //     let subtractCommission = 0;
  //     if (this.deposit) {
  //       subtractCommission = (profit) + (-(this.deposit * (environment.percentage_of_deduction / 100)));
  //     } else {
  //       subtractCommission = (profit) + (-(formValue.balanceDue * (environment.percentage_of_deduction / 100)));
  //     }
  //     this.model.companyProfit = subtractCommission;
  //     formValue.companyProfit = subtractCommission;
  //     this.form.get('companyProfit').setValue(subtractCommission);
  //     this.form.get('companyProfit').updateValueAndValidity()
  //   }

  //   if ((this.model?.order?.customerChargedType) && (this.model.order.brokerFeePaymentMethod) && (+this.model.order.brokerFeePaymentMethod == PaymentMethod['Credit Card'] || +this.model.order.brokerFeePaymentMethod == PaymentMethod.Paypal)) {
  //     const currentCompanyProfit: any = this.form.get('companyProfit').value;
  //     const brokerFee: any = this.getBrokerFee();
  //     if (brokerFee !== null) {
  //       const companyProfit = (currentCompanyProfit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));
  //       this.model.companyProfit = companyProfit;
  //       formValue.companyProfit = companyProfit;
  //       this.form.get('companyProfit').setValue(companyProfit);
  //       this.form.get('companyProfit').updateValueAndValidity()
  //     }
  //   }
  // }

  fscPaidByChange($event) {
    this.calculateCompanyProfits();
  }
  invoicePaidChange($event) {
    this.calculateCompanyProfits();
  }

  calculateAgentCommission() {
    let agentCommission = ((this.form.controls.adjustmentProfit.value * this.form.controls.salesAgentCommissionPercentage.value) / 100);
    this.form.get('agentCommission').setValue(agentCommission);
    this.form.get('agentCommission').updateValueAndValidity()
  }
}
@NgModule({
  declarations: [
    InvoiceFormComponent,
  ],
  imports: [
    ReactiveFormsModule,
    DialogModule,
    FormsModule,
    LoadingModule,
    DropdownModule,
    AutoCompleteModule,
    FormsModule,
    ButtonModule,
    LastUpdatedModule,
    DynamicValueModule,
    PaginatorCustomModule,
    SimpleControlModule,
    CheckboxModule,
    MultiSelectModule,
    ModalLeftNavModule,
    UploadsModule,
    CommonModule,
    NotesDetailModule
  ],
  exports: [
    InvoiceFormComponent,
  ]
})
export class InvoiceFormModule { }
